// Single destination entry point. Collapsed: "Where to?". With a destination:
// a small chip showing where the driver is heading. No permanent panel.

import React from "react";
import { Search, MapPin, X } from "lucide-react";

export default function DestinationPill({ journey, destination, onOpen, onClear }) {
  const dest = journey?.destination || destination;

  if (!dest) {
    return (
      <div className="absolute right-2 top-14 sm:right-3 sm:top-16 z-[1000]">
        <button
          type="button"
          onClick={onOpen}
          className="h-8 pl-2.5 pr-3 inline-flex items-center gap-1.5 rounded-full bg-[#0a0a0c]/75 border border-white/15 backdrop-blur-md text-[11px] font-medium text-zinc-100 active:scale-95 transition-transform"
          data-testid="destination-pill"
          aria-label="Search where you are going"
        >
          <Search className="w-3.5 h-3.5 text-[#ccff00]" />
          Where to?
        </button>
      </div>
    );
  }

  return (
    <div className="absolute right-2 top-14 sm:right-3 sm:top-16 z-[1000] max-w-[62%] flex items-center">
      <button
        type="button"
        onClick={onOpen}
        className="h-8 pl-2.5 pr-2 min-w-0 inline-flex items-center gap-1.5 rounded-l-full rounded-r-none bg-[#0a0a0c]/85 border border-[#ccff00]/30 border-r-0 backdrop-blur-md text-[11px] text-zinc-100 active:scale-95 transition-transform"
        data-testid="destination-chip"
      >
        <MapPin className="w-3.5 h-3.5 text-[#ccff00] shrink-0" />
        <span className="truncate max-w-[150px]" data-testid="destination-chip-name">
          {dest.name}
        </span>
        {journey?.selected && (
          <span className="text-zinc-400 whitespace-nowrap">· {journey.selected.type_label}</span>
        )}
      </button>
      <button
        type="button"
        onClick={onClear}
        className="h-8 w-7 shrink-0 inline-flex items-center justify-center rounded-r-full bg-[#0a0a0c]/85 border border-[#ccff00]/30 border-l-0 backdrop-blur-md text-zinc-400"
        data-testid="destination-clear"
        aria-label="Clear destination"
      >
        <X className="w-3.5 h-3.5" />
      </button>
    </div>
  );
}
